import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  channelTypeMap,
  channelTypeOptions,
} from '../../constants/channelType';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { channelTypePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';

import './index.scss';
import { NO_DATE } from '@/pages/opinion/constants';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function ChannelTypeSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const {
    selects: channelTypeSelects,
    setSelects: setChannelTypeSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    oriDefaultFilter,
    backOriDefaultValue,
    defaultKey: 'channel_type_select',
    options: channelTypeOptions.map((item) => item.value),
  });

  const { formatOptionsMessage, formatMessage } = useLanguage();

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'channel_type_select',
      commonBackInfo(
        { channel_type_select: channelTypeSelects },
        { [defaultKey]: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [channelTypeSelects, formatMessage]);

  const channelTypeValue = useMemo(() => {
    return channelTypeSelects.map(String);
  }, [channelTypeSelects]);

  return (
    <div className={`channel-type-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={channelTypePlaceholder[lang]}
        onClear={() => setChannelTypeSelects([])}
        buttonItemRender={(item: string) =>
          formatMessage({ id: channelTypeMap[item] || NO_DATE.EMPTY })
        }
        boxClassName="channel-type-select-box"
        selectOptionsInfo={[channelTypeValue, setChannelTypeSelects]}
        options={formatOptionsMessage(channelTypeOptions)}
        pointKey={FilterButtonPoint.channelType}
      ></CustomSelect>
    </div>
  );
}
